/**
 * @Author：zsj
 * @Date：2022/03/08
 */

import { handleActions } from 'redux-actions'
import ActionTypes from '../action-types'

const initialState = { name: 'hh' }


const homeReducer = handleActions({
    [ActionTypes.UPDATE_HOME_DATA]: (state, action) => {
        return {
            ...state,
            ...action.payload
        };
    },
}, initialState)

export default homeReducer;
